import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="my-12 flex flex-col items-center justify-center bg-white px-6">
      <div className="w-full max-w-md bg-white p-10 text-center">
        <h1 className="text-3xl font-bold text-gray-900">404 Not Found</h1>

        <p className="mt-3 text-lg text-gray-600">Pagina non trovata.</p>

        <Link
          to="/"
          className="mt-6 inline-block rounded-md bg-primary px-6 py-2 text-sm font-medium text-white hover:bg-primary/90"
        >
          Torna alla Home
        </Link>
      </div>
    </div>
  );
}
